import React from 'react';
import { FileIcon, ReportIcon, TrashIcon, WarnIcon } from '../icons';
import DocStatusBadge from './DocStatusBadge';
import { formatDate } from '../../utils/format';

export default function DocumentList({ documents, confirmDeleteId, copiedId, onDeleteClick, onCopyFilename, onViewReport }) {
  if (documents.length === 0) {
    return (
      <div className="prompts-empty">
        <span>No documents yet.</span>
        <span>Upload a file or index a URL.</span>
      </div>
    );
  }

  return (
    <div className="prompt-list">
      {documents.map(doc => (
        <div
          key={doc.id}
          className={`document-item ${confirmDeleteId === doc.id ? 'document-item--pending-delete' : ''}`}
        >
          <div className="document-item-icon">❯</div>
          <div className="document-item-info">
            <span
              className={`document-item-name document-item-name--clickable ${copiedId === doc.id ? 'document-item-name--copied' : ''}`}
              title={copiedId === doc.id ? 'Copied!' : 'Click to copy'}
              onClick={() => onCopyFilename(doc)}
            >
              {copiedId === doc.id ? '✓ Copied' : doc.filename}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '2px' }}>
              <span className="document-item-date">{formatDate(doc.uploaded_at)}</span>
              <DocStatusBadge status={doc.status} qualityVerdict={doc.quality_verdict} />
            </div>
          </div>
          {doc.status !== 'pending' && doc.ingest_report && (
            <button
              className="doc-report-btn"
              title="View processing report"
              onClick={() => onViewReport(doc)}
            >
              <ReportIcon />
            </button>
          )}
          <button
            className="doc-delete-btn"
            title="Delete"
            onClick={() => onDeleteClick(doc.id)}
          >
            <TrashIcon />
          </button>
        </div>
      ))}
    </div>
  );
}
